<template>
  <div class="ltr:pl-3 rtl:pr-3 min-w-[30px]">
    <niceone-image :src="$publicPath('/images/cart-buttons/wishlist.png')" width="20"
                   @click.stop.prevent="AddToWishList"/>
    <teleport :to="teleportTarget">
      <delete-popup v-model="showDeletePopup" :title="$t('cart.wishlist_alert_message')"
                    :confirmText="$t('common.yes')" :cancelText="$t('common.no')" :loading="loading" @cancel="onCancel"
                    @delete="onDelete"/>
    </teleport>
  </div>
</template>

<script setup>
import DeletePopup from "@/components/cart/DeletePopup.vue";
import {EVENTS} from "~/constants/events";

const emit = defineEmits(['add-to-wishlist'])
const props = defineProps({
  product: {
    type: Object,
    default: () => {
    }
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const {on} = useEventBus(EVENTS.DELETE_DIALOG)
on(() => onCancel())

const teleportTarget = computed(() => {
  if (process.client && useNuxtApp().$device.isDesktop && document.querySelector('#cart-popup')) {
    return '#cart-popup'
  }
  return 'body'
})

const showDeletePopup = ref(false)
const AddToWishList = () => {
  showDeletePopup.value = true
}

const onDelete = () => {
  emit('add-to-wishlist', {key: props?.product?.key, product_id: props?.product?.product_id})
  onCancel()
}
const onCancel = () => {
  showDeletePopup.value = false
}
</script>